import axios from '@/axios'
import { forEach } from 'core-js/fn/array';

let accessToken = localStorage.accessToken;
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`

export default {
	namespaced: true,
	state: {
		inventory_variant_log: [],
    product_variant: []
	},

	actions: {
		async inventoryLog({commit}, payload) {
      try {
      	let id = payload;
				await axios.get(`/variant/${id}`)
        .then((inventory) => {
        	if(inventory.data.data[0].log.length > 0){
		        commit('SET_VARIANT_INVENTORY_LOG', Object.assign({}, {variant_id:id, log:inventory.data.data[0].log}));
        	}
        })
        
      } catch (e) {
        throw e;
      }
    },
    async updateInventoryLog({commit}, payload) {
      try {
      	let id = payload.id;
        let inventory_count = payload.inventory_count;
      	let remarks = payload.remarks;
				await axios.patch(`variant/${id}/inventory`,{ inventory_count: inventory_count,remarks: remarks })
        .then((res) => {
        	console.log('updated');
        })
        .catch((err) => { console.log(err) })
        
      } catch (e) {
        throw e;
      }
    },
    async productVariantList({commit}, payload) {
      try {
        let product_variant = await axios.get('/product/variant/list');
        for(var key in product_variant.data.data){
          var options = '';
          if(product_variant.data.data[key].option.length > 0){
            for(var sub_key in product_variant.data.data[key].option){
              options+= product_variant.data.data[key].option[sub_key].label +': '+ product_variant.data.data[key].option[sub_key].value+'\n\n'
            }
          }
          product_variant.data.data[key].options = options
        }
        commit('SET_PRODUCT_VARIANTS', product_variant.data.data);
        
      } catch (e) {
        throw e;
      }
    }
	},

	getters: {
		inventory_variant_log: state => state.inventory_variant_log,
	},

	mutations: {
		SET_VARIANT_INVENTORY_LOG(state, payload) {
      state.inventory_variant_log[payload.variant_id] = [];
      state.inventory_variant_log[payload.variant_id] = payload.log;
    },
    SET_PRODUCT_VARIANTS(state, payload) {
      state.product_variant = payload;
    },
    UPDATE_PRODUCT_VARIANTS(state, payload) {
      state.product_variant[payload.index].inventory_count = payload.inventory_count;
    }
	}
}